<!-- New create/edit button -->
<div [ngClass]="{ 'has-edit-button': page.isPreview() }">
  <!-- edit button -->
  <ng-container
    *ngIf="page.isPreview()"
    [brManageContentButton]="document"
    parameter="document"
    [relative]="false"
    root=""
  >
  </ng-container>

  <!-- Render Content -->
  <div
    *ngIf="content"
    [edsSpacing]="marginBottom === 'auto' ? 'xl' : marginBottom"
  >
    <!-- Banner Display -->
    <ng-container [ngSwitch]="componentLabel">
      <!-- Standard Banner Component-->
      <ng-container *ngSwitchCase="'Banner'">
        <ng-container *ngTemplateOutlet="standardBanner"></ng-container>
      </ng-container>

      <!-- Impact Banner Component-->
      <ng-container *ngSwitchCase="'Banner Impact'">
        <eds-banner-impact-vi
          *ngIf="skin !== 'V2'"
          [title]="content.title"
          [summary]="content.subTitle"
          [imageSrc]="content.imageSrc"
          [caveatContent]="disclaimerCaveat"
          [hasViButton]="linkText ? true : false"
          [linkBtnText]="linkText"
          [linkBtnHref]="linkUrl"
          [signInRequired]="signInRequired"
        ></eds-banner-impact-vi>
        <eds-banner-impact-vi-2
          *ngIf="skin === 'V2'"
          [title]="content.title"
          [summary]="content.subTitle"
          [imageSrc]="content.imageSrc"
          [caveatContent]="disclaimerCaveat"
          [hasViButton]="linkText ? true : false"
          [linkBtnText]="linkText"
          [linkBtnHref]="linkUrl"
          [signInRequired]="signInRequired"
        ></eds-banner-impact-vi-2>

        <!-- TODO: CTA Buttons

 [hasButton]="content.button"
          [bannerBtnLabel]="content.button?.linkCompound?.displayText"

          <div edsPadding edsPaddingTop="lg">
            <ng-container *ngIf="content.button">
              <ng-container *ngTemplateOutlet="ctaButton"></ng-container>
            </ng-container>
          </div>  -->
      </ng-container>

      <!-- With Nav Component -->
      <eds-banner-nav
        *ngSwitchCase="'Banner (with nav)'"
        [theme]="theme ? theme : 'primary'"
        [breadcrumbItems]="showBreadcrumb ? breadcrumbItems : null"
        [preTitle]="content.category"
        [title]="content.title"
        [subTitle]="content.subTitle"
        [caveatContent]="disclaimerCaveat"
        [navCards]=""
      >
        <!-- CTA Buttons -->
        <ng-container *ngIf="content.button">
          <ng-container *ngTemplateOutlet="ctaButton"></ng-container>
        </ng-container>
      </eds-banner-nav>
      <!-- / With nav -->

      <!-- Impact Banner VI Component -->
      <ng-container *ngSwitchCase="'Banner Impact VI'">
        <eds-banner-impact-vi
          *ngIf="skin !== 'V2'"
          [title]="content.title"
          [summary]="content.subTitle"
          [imageSrc]="content.imageSrc"
          [caveatContent]="disclaimerCaveat"
          [hasViButton]="linkText ? true : false"
          [linkBtnText]="linkText"
          [linkBtnHref]="linkUrl"
        ></eds-banner-impact-vi>
        <eds-banner-impact-vi-2
          *ngIf="skin === 'V2'"
          [title]="content.title"
          [summary]="content.subTitle"
          [imageSrc]="content.imageSrc"
          [caveatContent]="disclaimerCaveat"
          [hasViButton]="linkText ? true : false"
          [linkBtnText]="linkText"
          [linkBtnHref]="linkUrl"
        ></eds-banner-impact-vi-2>
      </ng-container>
      <!-- Video Banner Component -->
      <ng-container *ngSwitchCase="'Banner Video'">
        <eds-banner-video
          [title]="content.title"
          [theme]="theme ? theme : 'primary'"
          [summary]="content.summary"
          [video]="video"
          [verticalLayout]="layout"
          [thematic]="thematic"
          [isHideTitle]="isHideTitle"
        >
          <!-- CTA Buttons -->
          <ng-container *ngIf="content.button?.length">
            <ng-container *ngTemplateOutlet="ctaButton"></ng-container>
          </ng-container>
          <!-- / CTA Buttons -->
        </eds-banner-video>
      </ng-container>

      <!-- Standard Default -->
      <ng-container *ngSwitchDefault>
        <ng-container *ngTemplateOutlet="standardBanner"></ng-container>
      </ng-container>
    </ng-container>

    <!-- Standard Template-->
    <ng-template #standardBanner>
      <eds-banner-standard
        [theme]="theme ? theme : 'primary'"
        [breadcrumbItems]="showBreadcrumb ? breadcrumbItems : null"
        [preTitle]="content.category"
        [title]="content.title"
        [titleLevel]="1"
        [titleSize]="'h1'"
        [subTitle]="content.subTitle"
        [imageSrc]="content.imageSrc"
        [logoLink]="content.logoLink"
        [altlogoText]="content.altlogoText"
        [wide]="true"
        [videoAccountId]="content.video?.accountId"
        [videoId]="content.video?.videoId"
        [videoPlayerId]="content.video?.videoPlayerId"
        [videoTranscript]="content.video?.videoTranscript"
        [caveatContent]="disclaimerCaveat"
        [hasRibbon]="ribbon"
      >
        <div>
          <!-- CTA Buttons -->
          <ng-container *ngIf="content.button?.length">
            <ng-container *ngTemplateOutlet="ctaButton"></ng-container>
          </ng-container>
          <!-- / CTA Buttons -->

          <!-- Important information link -->
          <ng-container *ngIf="content.importantinformationlink?.displayText">
            <div edsPadding edsPaddingTop="lg">
              <eds-link-item
                [theme]="'light'"
                [href]="content.importantinformationlink?.url"
                [title]="content.importantinformationlink?.displayText"
                [isNewWindow]="content.importantinformationlink?.target"
                [isExternal]="content.importantinformationlink?.external"
                [externalSuffix]="
                  content.importantinformationlink?.externalSuffix
                "
                (click)="processLink($event, content.importantinformationlink)"
                [analyticsNoEvent]="true"
              ></eds-link-item>
            </div>
          </ng-container>
          <!-- / Important information link -->
        </div>
      </eds-banner-standard>
    </ng-template>

    <!-- Wayfinder link target for impact banner -->
    <ng-container [ngSwitch]="componentLabel">
      <span *ngSwitchCase="'Banner Impact'" id="wayfinder"></span>
    </ng-container>
  </div>
  <!-- CTA Button template -->
  <ng-template #ctaButton>
    <ng-container *ngIf="content.button.length">
      <div edsFlexbox alignItems="center" flexWrap="wrap">
        <ng-container *ngFor="let button of content.button">
          <div>
            <ng-container *ngIf="button.buttonStyle !== 'link'">
              <!-- button -->
              <a
                [edsButton]="button.buttonStyle"
                [title]="button.linkCompound.title"
                [ngClass]="button.linkCompound?.externalLink"
                [href]="button.linkCompound.url"
                [target]="button.linkCompound.target"
                (click)="processLink($event, button.linkCompound)"
                [attr.data-signin-required]="button.signInRequired"
                data-analytics-no-event="true"
              >
                <span class="ft__btn__txt">{{
                  button.linkCompound.displayText
                }}</span>
              </a>
            </ng-container>
            <ng-container *ngIf="button.buttonStyle === 'link'">
              <!-- link -->
              <eds-link-item
                [theme]="'light'"
                [href]="button.linkCompound.url"
                [title]="button.linkCompound.displayText"
                [isNewWindow]="button.linkCompound.target"
                [isExternal]="button.linkCompound?.externalLink"
                [externalSuffix]="button.linkCompound?.externalSuffix"
                (click)="processLink($event, button.linkCompound)"
                [attr.data-signin-required]="button.signInRequired"
                [analyticsNoEvent]="true"
              ></eds-link-item>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </ng-template>

  <!-- No Document -->
  <div *ngIf="!content && page.isPreview()" class="no-document">
    <div edsGrid class="no-document__component">
      <div class="no-document__overlay">
        Click to configure <strong>{{ componentLabel }}</strong>
      </div>
    </div>
  </div>
</div>
